/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChatFileGroundingInfoModel
 */
export interface ChatFileGroundingInfoModel {
    /**
     * 
     * @type {string}
     * @memberof ChatFileGroundingInfoModel
     */
    fileName: string;
    /**
     * 
     * @type {number}
     * @memberof ChatFileGroundingInfoModel
     */
    fileSizeInBytes: number;
}

/**
 * Check if a given object implements the ChatFileGroundingInfoModel interface.
 */
export function instanceOfChatFileGroundingInfoModel(value: object): value is ChatFileGroundingInfoModel {
    if (!('fileName' in value) || value['fileName'] === undefined) return false;
    if (!('fileSizeInBytes' in value) || value['fileSizeInBytes'] === undefined) return false;
    return true;
}

export function ChatFileGroundingInfoModelFromJSON(json: any): ChatFileGroundingInfoModel {
    return ChatFileGroundingInfoModelFromJSONTyped(json, false);
}

export function ChatFileGroundingInfoModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatFileGroundingInfoModel {
    if (json == null) {
        return json;
    }
    return {
        
        'fileName': json['fileName'],
        'fileSizeInBytes': json['fileSizeInBytes'],
    };
}

export function ChatFileGroundingInfoModelToJSON(json: any): ChatFileGroundingInfoModel {
    return ChatFileGroundingInfoModelToJSONTyped(json, false);
}

export function ChatFileGroundingInfoModelToJSONTyped(value?: ChatFileGroundingInfoModel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fileName': value['fileName'],
        'fileSizeInBytes': value['fileSizeInBytes'],
    };
}

